<template>


        <div class="datepicker rounded flex">


            <div class="border border-gray-300">


                <input type="text" ref="start_at" :value="start_at" placeholder="Choose start and end date" class="startDate" required value="" />


            </div>


            <font-awesome-icon
                class="justify-center font-bold mx-8 self-center"
                style="width: 14px; height: 21px; color: black;"
                size="sm"
                :icon="['fas', 'arrow-right']"/>


            <div class="border border-gray-300">


                <input type="text" ref="end_at" :value="end_at" class="endDate" required>


            </div>


        </div>


</template>


<script>
import { defineComponent } from "vue";
import flatpickr from "flatpickr";
import 'flatpickr/dist/flatpickr.css';
import { Danish } from 'flatpickr/dist/l10n/da.js';
import rangePlugin from "flatpickr/dist/plugins/rangePlugin";

// Docs - https://github.com/ankurk91/vue-flatpickr-component

export default defineComponent({

    components: {

    },

    props: {
        start_at: {
            type: String,
            default: '2021-10-01 00:00:00.000000Z'
        },
        end_at: {
            type: String,
            default: '2021-10-01 00:00:00.000000Z'
        },
        language: {
            type: Object,
            default:
                () => {
                    return {
                        firstDayOfWeek: 1,
                        time_24hr: true,
                    }
                }
        },
        min_date: {
            type: String,
            default: 'today'
        }
    },

    mounted() {
        this.flatPickr = flatpickr(this.$refs.start_at, {
            enableTime: true,
            allowInput: true,
            // minDate: this.min_date,
            mode: 'range',
            locale: this.language,
            dateFormat: "d/m/Y H:i",
            "plugins": [new rangePlugin({ input: this.$refs.end_at})],
            onChange:(selectedDates, value, instance) => {

                this.$emit('start_at_changed',moment( selectedDates[0] ).format() );
                this.$emit('end_at_changed',moment( selectedDates[1] ).format() );

            },
        });
    },


    data() {
        Danish.firstDayOfWeek = 0;
        return {
            flatPickr: null,
            config: {
                defaultDate: this.value,
                wrap: true,
                altFormat: 'd / m / Y',
                altInput: true,
                minDate: this.min_date,
                locale: this.language,
                mode: 'range',
                conjunction: 'hej',
                allowInput: false,
                onChange:(selectedDates, value, instance) => {

                    this.$emit('new_date',moment( selectedDates[0] ).format() );

                },
                plugins: {
                    "plugins": [new rangePlugin({ input: "#secondRangeInput"})]

                }
            },
        }
    },


    watch: {

        min_date: function(current,prev) {

            this.config.minDate = current;

        }
    }
});
</script>

<style scoped>

</style>
